import type { VoucherDisplayConfig } from 'api/promo'

export function matchUrlPath(pattern: string, pathname: string): boolean {
  if (pattern.endsWith('/*')) {
    return pathname.startsWith(pattern.slice(0, -1))
  }

  return pathname === pattern
}

export function passesAuthState(authState: VoucherDisplayConfig['authState'], isLoggedIn: boolean): boolean {
  if (authState === 'logged_in_and_out') return true
  if (authState === 'logged_in') return isLoggedIn
  if (authState === 'logged_out') return !isLoggedIn
  return false
}
